import { render, staticRenderFns } from "./DownloadTransaction.vue?vue&type=template&id=ea608a00"
import script from "./DownloadTransaction.vue?vue&type=script&lang=js"
export * from "./DownloadTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports